import React from "react";
import { useNavigate } from "react-router-dom";
import background from "./images/background.png";

const FeedbackSelect = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="max-w-xl mx-auto text-center px-5 py-6"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.12)",
        }}
      >
        <h1 className="text-xl font-bold mb-5" style={{ color: "#b06ab3" }}>
          🛠️ ¿Algo no funciona o quieres dejar feedback?
        </h1>

        <div className="grid grid-cols-2 gap-4 text-center">
          <button
            onClick={() => navigate("/feedback/bug")}
            className="p-6 rounded-2xl font-bold text-sm active:scale-95 transition-transform"
            style={{
              background: "rgba(249,168,212,0.15)",
              border: "2px solid #f9a8d4",
              color: "#be185d",
            }}
          >
            🐞 Algo no funciona
          </button>
          <button
            onClick={() => navigate("/feedback/sugerencia")}
            className="p-6 rounded-2xl font-bold text-sm active:scale-95 transition-transform"
            style={{
              background: "rgba(196,181,253,0.15)",
              border: "2px solid #c4b5fd",
              color: "#6d28d9",
            }}
          >
            💖 Quiero dejar feedback
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackSelect;
